import { appRouterPaths } from 'services/navigation';
import { BellSchedulesPage } from 'pages/BellSchedules';
import type { AppRouteProps } from '../types';

export const bellSchedulesPageRoute: AppRouteProps = {
  path: appRouterPaths.bellSchedules,
  element: <BellSchedulesPage />,
};
